import {
    Component,
    ElementRef,
    HostBinding,
    Input,
    ViewChild,
    AfterContentInit // Import AfterContentInit
} from '@angular/core';

enum AlertColors {
    success = 'success',
    warning = 'warning',
    danger = 'danger',
    info = 'info',
}

@Component({
    selector: 'ui-alert',
    templateUrl: './ui-alert.component.html',
    styleUrls: ['./ui-alert.component.scss'],
    standalone: false
})
// Implement the lifecycle hook
export class UiAlertComponent implements AfterContentInit {
    @Input() label: string;
    @Input() variant: keyof typeof AlertColors = AlertColors.success;

    @HostBinding('class') get className() {
        return `ui-alert__${this.variant}`;
    }

    @ViewChild('content') content: ElementRef;

    showText: boolean = false;

    ngAfterContentInit(): void {
        setTimeout(() => {
            if (this.content?.nativeElement) {
                this.showText = this.content.nativeElement.childElementCount > 0;
            }
        });
    }

    get iconClass() {
        switch (this.variant) {
            case 'success':
                return 'fa fa-check-circle';
            case 'warning':
                return 'fa fa-exclamation-circle';
            case 'danger':
                return 'fa fa-stop-circle';
            case 'info':
                return 'fa fa-info-circle';
            default:
                return 'fa fa-check-circle';
        }
    }
}
